import { NavLink, useParams } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import "./Teamstanding.css";
import backArrow from "../../../../images/arrow.png";
import whiteArrow from "../../../../images/white-arrow.png";
import logo from "../../../../components/images/logo.png";
import Skeleton from "../../../../components/Skeleton";
import { Helmet } from "react-helmet-async";

const Teamstanding = ({ dark, myteam, teamId, MyBaseUrl }) => {
  const createSlug = (name) => {
    return name
      ?.toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
  };

  const team = myteam || null;

  const slug = team
    ? `${team.name?.toLowerCase().replace(/\s+/g, "-")}-${team.api_id || team.id}`
    : "";

  const [leagueInfo, setLeagueInfo] = useState([]);
  const [rank, setRank] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStandings = async () => {
      if (!teamId) return;

      try {
        setLoading(true);
        setError(null);

        const response = await fetch(`${MyBaseUrl}/teams/${teamId}/standings`);

        if (!response.ok) {
          throw new Error("Failed to fetch standings");
        }

        const data = await response.json();

        const leagues = data?.data || [];
        setLeagueInfo(Array.isArray(leagues) ? leagues : []);

        let foundRank = null;

        leagues.forEach((item) => {
          item?.league?.standings?.forEach((group) => {
            group.forEach((t) => {
              if (String(t?.team?.api_id) === String(teamId)) {
                foundRank = t;
              }
            });
          });
        });

        setRank(foundRank);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStandings();
  }, [teamId, MyBaseUrl]);

  const getBorderColor = (description) => {
    if (!description) return "4px solid transparent";

    const text = description.toLowerCase();

    if (text.includes("champions")) return "4px solid #16a34a";
    if (text.includes("europa")) return "4px solid #f97316";
    if (text.includes("conference")) return "4px solid #3b82f6";
    if (text.includes("promotion")) return "4px solid #16a34a";
    if (text.includes("relegation")) return "4px solid #ef4444";
    if (text.includes("ranking")) return "4px solid #a1a1aa";

    return "4px solid transparent";
  };

  const legendTypes = useMemo(() => {
    const types = new Set();

    leagueInfo.forEach((leagueItem) => {
      leagueItem?.league?.standings?.forEach((group) => {
        group.forEach((team) => {
          const desc = team?.description?.toLowerCase() || "";

          if (desc.includes("champions") || desc.includes("promotion")) {
            types.add("champions");
          }

          if (desc.includes("europa")) {
            types.add("europa");
          }

          if (desc.includes("conference")) {
            types.add("conference");
          }

          if (desc.includes("relegation")) {
            types.add("relegation");
          }

          if (desc.includes("ranking")) {
            types.add("ranking");
          }
        });
      });
    });

    return types;
  }, [leagueInfo]);

  const Standing = [
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
    { p: "11" },
  ];

  const [isStickyTop, setIsStickyTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 600) {
        if (window.scrollY >= 98) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      } else {
        if (window.scrollY >= 300) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {team?.name
            ? `${team.name} Standings & League Table | Goal Arena`
            : "Team Standings | Goal Arena"}
        </title>

        <meta
          name="description"
          content={
            team?.name
              ? `Check ${team.name} current league standings, points, wins, losses, goal difference and table position across competitions on Goal Arena.`
              : "View football team standings, league tables, rankings and points across competitions on Goal Arena."
          }
        />

        <meta
          name="keywords"
          content={`${team?.name || "football team"}, standings, league table, points table, rankings, football standings, Goal Arena`}
        />

        <meta
          property="og:title"
          content={`${
            team?.name || "Team"
          } Standings & League Table | Goal Arena`}
        />

        <meta
          property="og:description"
          content={`Track ${
            team?.name || "your favorite team"
          } standings, table position, points and form across competitions.`}
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content={`https://yourdomain.com/teams/${slug}/standings`}
        />
        <meta
          property="og:image"
          content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"
        />
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content={`${team?.name || "Team"} Standings | Goal Arena`}
        />

        <meta
          name="twitter:description"
          content={`Latest standings, points and rankings for ${
            team?.name || "this football team"
          }.`}
        />

        <meta name="twitter:image" content={team?.logo || ""} />

        <link
          rel="canonical"
          href={`https://yourdomain.com/teams/${slug}/standings`}
        />
      </Helmet>

      <div className="homer">
        <div className="teamstandingWrapper">
          {/* <NavLink
            to="/teams"
            style={{ textDecoration: "none" }}
            className="ppp">
            <strong
              style={{
                cursor: "pointer",
                backgroundColor: "transparent",
                border: "none",
                color: dark ? "white" : "black",
                padding: "5px 10px",
                borderRadius: "5px",
              }}>
              {dark ? (
                <img
                  src={whiteArrow}
                  alt=""
                  className="whitearrow"
                  style={{ transform: "rotate(180deg)", scale: "0.7" }}
                />
              ) : (
                <img src={backArrow} alt="" className="blackarrow" />
              )}
            </strong>
          </NavLink>

          <section
            className="section1"
            style={
              dark
                ? { backgroundColor: "#272727ff" }
                : { backgroundColor: "whitesmoke" }
            }>
            <div>
              <img src={team?.logo} alt={team?.name} />
              <h1 style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
                {team?.name}
              </h1>
            </div>

            <span>
              <strong style={dark ? { color: "#e2e1e1ff" } : {}}>
                Country: {team?.country}
              </strong>

              <strong style={dark ? { color: "#e2e1e1ff" } : {}}>
                Stadium: {team?.venue_name}
              </strong>
            </span>

            <nav
              style={
                dark
                  ? {
                      backgroundColor: "#333333ff",
                      color: "#fff",
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      transform: isStickyTop
                        ? "translateX(-0%)"
                        : "translateX(0)",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
                  : {
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
              }>
              <ul style={{ backgroundColor: "transparent" }}>
                <NavLink
                  to={`/teams/${slug}`}
                  style={{ textDecoration: "none" }}>
                  <li className="navlink">Overview</li>
                </NavLink>

                <NavLink
                  to={`/teams/${slug}/news`}
                  style={{ textDecoration: "none" }}>
                  <li className="navlink">News</li>
                </NavLink>

                <NavLink
                  to={`/teams/${slug}/standings`}
                  style={{ textDecoration: "none" }}>
                  <li className="myactive">Standings</li>
                </NavLink>

                <NavLink
                  to={`/teams/${slug}/matches`}
                  style={{ textDecoration: "none" }}>
                  <li className="navlink">Matches</li>
                </NavLink>

                <NavLink
                  to={`/teams/${slug}/squad`}
                  style={{ textDecoration: "none" }}>
                  <li className="navlink">Squad</li>
                </NavLink>
              </ul>
            </nav>
          </section> */}

          {loading ? (
            <p style={{ marginTop: "0px" }}>
              <Skeleton dark={dark} count={6} />
            </p>
          ) : error ? (
            <h2 id="h1">{error}</h2>
          ) : leagueInfo.length === 0 ? (
            <h2
              id="h1"
              style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
              No standings available
            </h2>
          ) : (
            <section className="overall">
              {leagueInfo.map((leagueItem, leagueIndex) => {
                const standings = leagueItem?.league?.standings || [];

                return (
                  <section key={leagueIndex} className="wrap">
                    <h1
                      id="h1"
                      style={
                        dark ? { color: "#fafafaff" } : { color: "#161819" }
                      }>
                      {leagueItem?.league?.name || "League"}
                    </h1>

                    {standings.map((group, groupIndex) => (
                      <section key={groupIndex}>
                        <div className="tablehead">
                          <nav>
                            <h2>POS</h2>
                            <h2>TEAM</h2>
                          </nav>

                          <span>
                            <h2>P</h2>
                            <h2>W</h2>
                            <h2>D</h2>
                            <h2>L</h2>
                            <h2>GD</h2>
                            <h2>PTS</h2>
                          </span>
                        </div>

                        <section className="onlysection">
                          {group.map((teamData, index) => (
                            <div
                              key={teamData?.team?.id || index}
                              style={
                                dark
                                  ? {
                                      backgroundColor:
                                        teamData?.team?.id === team?.id
                                          ? "#333333ff"
                                          : "#222",
                                      color: "#fff",
                                      borderRadius: "30px",
                                      boxShadow:
                                        "1px 1px 30px rgba(0,0,0,0.39)",
                                      borderLeft: getBorderColor(
                                        teamData?.description,
                                      ),
                                    }
                                  : {
                                      borderLeft: getBorderColor(
                                        teamData?.description,
                                      ),
                                    }
                              }>
                              <nav>
                                <h2
                                  style={
                                    dark
                                      ? { color: "#fafafaff" }
                                      : { color: "#3e3f3f" }
                                  }>
                                  {teamData?.rank}
                                </h2>

                                <h2>
                                  <NavLink
                                    to={`/teams/${createSlug(teamData?.team?.name)}-${teamData?.team?.id}`}>
                                    <img
                                      src={teamData?.team?.logo}
                                      width="20"
                                      alt={teamData?.team?.name}
                                    />
                                  </NavLink>

                                  <NavLink
                                    to={`/teams/${createSlug(teamData?.team?.name)}-${teamData?.team?.id}`}>
                                    <span
                                      className="longName"
                                      style={
                                        dark
                                          ? { color: "#fafafaff" }
                                          : { color: "#3e3f3f" }
                                      }>
                                      {teamData?.team?.name}
                                    </span>

                                    <span
                                      className="codeName"
                                      style={
                                        dark
                                          ? { color: "#fafafaff" }
                                          : { color: "#3e3f3f" }
                                      }>
                                      {teamData?.team?.code}
                                    </span>
                                  </NavLink>
                                </h2>
                              </nav>

                              <span>
                                <h2
                                  style={
                                    dark
                                      ? { color: "#fafafaff" }
                                      : { color: "#3e3f3f" }
                                  }>
                                  {teamData?.all?.played}
                                </h2>
                                <h2
                                  style={
                                    dark
                                      ? { color: "#fafafaff" }
                                      : { color: "#3e3f3f" }
                                  }>
                                  {teamData?.all?.win}
                                </h2>
                                <h2
                                  style={
                                    dark
                                      ? { color: "#fafafaff" }
                                      : { color: "#3e3f3f" }
                                  }>
                                  {teamData?.all?.draw}
                                </h2>
                                <h2
                                  style={
                                    dark
                                      ? { color: "#fafafaff" }
                                      : { color: "#3e3f3f" }
                                  }>
                                  {teamData?.all?.lose}
                                </h2>
                                <h2
                                  style={
                                    dark
                                      ? { color: "#fafafaff" }
                                      : { color: "#3e3f3f" }
                                  }>
                                  {teamData?.goalsDiff}
                                </h2>
                                <h2
                                  style={
                                    dark
                                      ? { color: "#fafafaff" }
                                      : { color: "#3e3f3f" }
                                  }>
                                  {teamData?.points}
                                </h2>
                              </span>
                            </div>
                          ))}
                        </section>

                        {legendTypes.size > 0 && (
                          <div className="elim-wrap">
                            {legendTypes.has("champions") && (
                              <div className="elim">
                                <span
                                  style={{
                                    width: "12px",
                                    height: "12px",
                                    background: "#16a34a",
                                    borderRadius: "3px",
                                  }}></span>
                                <small
                                  style={
                                    dark
                                      ? { color: "#ccc" }
                                      : { color: "#161819" }
                                  }>
                                  Champions League / Promotion
                                </small>
                              </div>
                            )}

                            {legendTypes.has("europa") && (
                              <div className="elim">
                                <span
                                  style={{
                                    width: "12px",
                                    height: "12px",
                                    background: "#f97316",
                                    borderRadius: "3px",
                                  }}></span>
                                <small
                                  style={
                                    dark
                                      ? { color: "#ccc" }
                                      : { color: "#161819" }
                                  }>
                                  Europa League
                                </small>
                              </div>
                            )}

                            {legendTypes.has("conference") && (
                              <div className="elim">
                                <span
                                  style={{
                                    width: "12px",
                                    height: "12px",
                                    background: "#3b82f6",
                                    borderRadius: "3px",
                                  }}></span>
                                <small
                                  style={
                                    dark
                                      ? { color: "#ccc" }
                                      : { color: "#161819" }
                                  }>
                                  Conference League
                                </small>
                              </div>
                            )}

                            {legendTypes.has("relegation") && (
                              <div className="elim">
                                <span
                                  style={{
                                    width: "12px",
                                    height: "12px",
                                    background: "#ef4444",
                                    borderRadius: "3px",
                                  }}></span>
                                <small
                                  style={
                                    dark
                                      ? { color: "#ccc" }
                                      : { color: "#161819" }
                                  }>
                                  Relegation
                                </small>
                              </div>
                            )}

                            {legendTypes.has("ranking") && (
                              <div className="elim">
                                <span
                                  style={{
                                    width: "12px",
                                    height: "12px",
                                    background: "#a1a1aa",
                                    borderRadius: "3px",
                                  }}></span>
                                <small
                                  style={
                                    dark
                                      ? { color: "#ccc" }
                                      : { color: "#161819" }
                                  }>
                                  Ranking
                                </small>
                              </div>
                            )}
                          </div>
                        )}
                      </section>
                    ))}
                  </section>
                );
              })}
            </section>
          )}
        </div>
      </div>
    </>
  );
};

export default Teamstanding;
